import  { createContext, Dispatch } from 'react';
import enUS from './locale/en-US'

export const LocaleContext = createContext<'en-US' | 'zh-Hans'>('en-US');
export const LocaleDispatchContext = createContext<Dispatch<{ type: string, payload: 'en-US' | 'zh-Hans' }>>(() => {});
export const LocaleFileContext = createContext(enUS);
